<div class="dev-toolbar-root">
  <button
    type="button"
    class="dev-toolbar-fab"
    [attr.aria-label]="constants.labels.toggleAriaLabel"
    [attr.aria-expanded]="isOpen"
    (click)="togglePanel()"
  >
    {{ constants.labels.toggleButton }}
  </button>

  @if (isOpen) {
    <div class="dev-toolbar-panel" role="toolbar">
      <div class="dev-toolbar-row">
        <span class="dev-toolbar-label">{{ constants.labels.isBrowser }}</span>
        <label class="dev-toolbar-switch">
          <input
            type="checkbox"
            class="dev-toolbar-switch-input"
            [checked]="cs.isBrowser"
            (change)="onIsBrowserChange($any($event.target).checked)"
          />
          <span class="dev-toolbar-switch-track" aria-hidden="true">
            <span class="dev-toolbar-switch-thumb"></span>
          </span>
        </label>
      </div>
      <button
        type="button"
        class="dev-toolbar-action"
        (click)="simulateHydration()"
      >
        {{ constants.labels.simulateHydration }}
      </button>
    </div>
  }
</div>
